<template>
  <div>
    <!--上左右结构框架-->
    <Headbar></Headbar>
    <div class="iframebox">
      <div class="imleft" v-if="sidebarshow">
        <div>
          <div class="myinfo">
            <div class="avatar"><img src="@/assets/avatar_user.jpg"></div>
            <div class="infodata">
              <div class="usercompany">{{greet}}~{{uscompany}}</div>
              <!-- <div class="latelylog">上次登录时间：<p>{{$store.state.lastime}}</p></div> -->
            </div>
          </div>
          <!-- <div class="sidemenu" :class="sidename=='a'?'dow':'up'">
            <h4  @click="navlick('a')"><i class="iconfont icon-pingtaishouquan"></i>认证审核</h4>
            <ul class="itemnavlist">
              <router-link tag='li' @click.native="buffer('businessauth')"  to="/bankacceptance/businessauth" :class="memorystick=='businessauth'?'on':''">工商认证</router-link>
              <li :class="branch?'on':'off'" ><div class="iconfont icon-jiantou12" @click="subbranch()">打款认证</div>
                <ul>
                  <router-link tag='li' to="/bankacceptance/payauth" :class="memorystick=='payauth'?'onon':''" @click.native="buffer('payauth')" >待打款</router-link>
                  <router-link tag='li' to="/bankacceptance/payauthentication" :class="memorystick=='payauthentication'?'onon':''" @click.native="buffer('payauthentication')" >认证中</router-link>
                </ul>
              </li>
            </ul>
          </div> -->
          <!-- <div class="sidemenu"  :class="sidename=='b'?'dow':'up'">
            <h4 @click="navlick('b')"><i class="iconfont icon-gerendangan"></i>数据更新</h4>
            <ul class="itemnavlist">
              <router-link tag='li' to="/bankacceptance/discountdata" :class="memorystick=='discountdata'?'onon':''" @click.native="buffer('discountdata')" >贴现数据</router-link>
              <router-link tag="li" to="/bankacceptance/interestrate" :class="memorystick=='interestrate'?'onon':''" @click.native="buffer('interestrate')" >网商承兑行更新</router-link>
              <router-link tag="li" to="/bankacceptance/webankintrupdate" :class="memorystick=='webankintrupdate'?'onon':''" @click.native="buffer('webankintrupdate')" >微众银行利率更新
            </router-link>
            </ul>
          </div> -->
          <div class="sidemenu"  :class="sidename=='c'?'dow':'up'">
            <h4  @click="navlick('c')"><i class="iconfont icon-31paixingbang"></i>订单管理</h4>
            <ul class="itemnavlist">
              <ul class="itemnavlist">
                <router-link tag='li' to="/bankacceptance/Custom" :class="memorystick=='Custom'?'onon':''" @click.native="buffer('Custom')" >订单查询</router-link>
                <router-link tag='li' to="/bankacceptance/Fedex" :class="memorystick=='Custom'?'onon':''" @click.native="fedex('Custom')" >FEDEX单号查询</router-link>
                <!-- <router-link tag="li" to="/bankacceptance/Static" :class="memorystick=='Static'?'onon':''" @click.native="buffer('Static')" >业务统计</router-link> -->
              </ul>
            </ul>
          </div>
          <div class="sidemenu"  :class="sidename=='k'?'dow':'up'">
            <h4  @click="navlick('k')"><i class="iconfont icon-31paixingbang"></i>用户管理</h4>
            <ul class="itemnavlist">
              <ul class="itemnavlist">
                <router-link tag='li' to="/bankacceptance/Control" :class="memorystick=='Custom'?'onon':''" @click.native="buffer('Custom')" >用户查询</router-link>
                <!-- <router-link tag="li" to="/bankacceptance/Static" :class="memorystick=='Static'?'onon':''" @click.native="buffer('Static')" >业务统计</router-link> -->
              </ul>
            </ul>
          </div>
         <div class="sidemenu"  :class="sidename=='z'?'dow':'up'">
            <h4  @click="navlick('z')"><i class="iconfont icon-31paixingbang"></i>系统设置</h4>
            <ul class="itemnavlist">
              <ul class="itemnavlist">
                <!-- <router-link tag='li' to="/bankacceptance/BankManagement" :class="memorystick=='BankManagement'?'onon':''" @click.native="buffer('BankManagement')" >路由设置</router-link> -->
                <!-- <router-link tag="li" to="/bankacceptance/advlist" :class="memorystick=='advlist'?'onon':''" @click.native="buffer('advlist')" >广告设置</router-link> -->
                <!-- <router-link tag="li" to="/bankacceptance/channel" :class="memorystick=='channel'?'onon':''" @click.native="buffer('channel')" >渠道设置</router-link> -->
                <router-link tag="li" to="/bankacceptance/Toto" :class="memorystick=='Toto'?'onon':''" @click.native="buffer('Toto')" >参数设置</router-link>
              </ul>
            </ul>
          </div> 
<!-- 
          <div class="sidemenu"  :class="sidename=='d'?'onno':''">
            <h4 @click="navlick('d')"><i class="iconfont icon-iconfinderbank"></i>路由设置</h4>
          </div>
          <div class="sidemenu"  :class="sidename=='e'?'onno':''">
            <h4  @click="navlick('e')"><i class=" ayy iconfont icon-web-icon-ad"></i>广告设置</h4>
          </div>
          <div class="sidemenu"  :class="sidename=='f'?'onno':''">
            <h4  @click="navlick('f')"><i class=" ayy iconfont icon-iconfinderbank"></i>渠道设置</h4>
          </div> -->
          <!-- <div class="sidemenu"  :class="sidename=='g'?'onno':''">
            <h4  @click="navlick('g')"><i class=" ayy iconfont icon-web-icon-ad"></i>参数设置</h4>
          </div> -->
          <!-- <div class="sidemenu"  :class="sidename=='h'?'onno':''">
            <h4  @click="navlick('h')"><i class=" ayy iconfont icon-web-icon-ad"></i>推荐人管理</h4>
          </div> -->
        </div>
      </div>
      <div class="imright">
            <span class="toright helpcapsule" v-if="sidebarshow" @click="sidebaroperation()"><span class="iconfont icon-jiantou23"></span>向左收起</span>
            <span class="toleft helpcapsule" v-else  @click="sidebaroperation()"><span class="iconfont icon-jiantou24"></span>向右打开</span>
        <router-view :key="refdata" v-if="isRouterAlive"/>
      </div>
    </div>
  </div>
</template>
<script>
//calc
import Headbar from '@/components/headbar'
export default {
  components: {
    Headbar
  },
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      greet:'',
      uscompany:'',
      sidename:'a',
      branch:false,
      memorystick:"businessauth",
      sidebarshow:true,
      refdata:0,
      isRouterAlive:true
    }
  },
  mounted:function() {
     this.usid=this.$store.state.userid
    this.uscompany=this.$store.state.user
    var d= new Date();
    if(d.getHours()<5){
      this.greet="凌晨了，注意休息"
    }
    else if(d.getHours()>=5&&d.getHours()<11){
      this.greet="早上好"
    }
    else if(d.getHours()>=11&&d.getHours()<13){
      this.greet="中午好"
    }
    else if(d.getHours()>=13&&d.getHours()<18){
      this.greet="下午好"
    }
    else if(d.getHours()>=18&&d.getHours()<24){
      this.greet="晚上好"
    }
  },
  methods: {
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      })
    },
    sidebaroperation(){
      this.sidebarshow=!this.sidebarshow
    },
     buffer(val){
       this.memorystick=val
     },
     subbranch(){
       this.branch=!this.branch
     },
     refresh(val){
       this.refdata=new Date().getTime()
       console.log(this.refdata)
     },
     navlick(val){
        if(this.sidename==val&&val!='d'&&val!='e'&&val!='f'&&val!='g'&&val!='h'){
          this.sidename=''
        }
        else{
          this.sidename=val
        }
        if(val=='d'){
          this.$router.push({name:'BankManagement'})
        }
        if(val=='e'){
          this.$router.push('/bankacceptance/advlist')
        }
        if(val=='f'){
          this.$router.push('/bankacceptance/channel')
        }
        if(val=='g'){
          this.$router.push('/bankacceptance/Toto')
        }
        if(val=='h'){
          this.$router.push('/bankacceptance/Recom')
        }
      }
  }
}
</script>
<style>
body{background-color: #F5F8FC;}
.iframebox{
  padding-top: 90px;
  width:100%;
  height:calc(100% - 90px);
  height:calc( 100vh - 90px);
  display: flex; 
}
.imleft{
  flex: none; 
  width: 200px; 
  overflow-y: auto; 
  display: block;
  background: #4C98E6;
}
.imright{
  flex: auto; 
  display: flex; 
  flex-direction: column; 
  overflow-y: auto; 
  padding:30px 25px 30px 25px;
  background: #F5F8FC;
  position: relative;
}
.itemnavlist>li{
  width:100%;
  color:#fff;
  min-height:45px;
  line-height:45px;
  font-size: 16px;
  cursor: pointer;
  text-indent: 60px;
}
.itemnavlist>li::before{
  font-size: 22px; 
  margin:15px;
}
.itemnavlist>li.current{
  background-color:#3A84EC;
  cursor: default;
}
.myinfo{ 
  margin-top: 32px;
  display: table;
  width: 100%;
  clear: both;
  margin-bottom:35px
}
.avatar{
  width:90px;
  height:90px;
  margin:36px auto;
}
.infodata{
  float: left;
}
.infodata{ 
  text-align: center;
  width:100%;
}
.avatar img{
  border-radius: 100%;
  overflow: hidden;
  width:90px;
  height:90px;
}
.usercompany{
  font-size:14px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:20px;
}
.latelylog{
  font-size:12px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:17px;
  margin-top:13px;
}
.latelylog p{
  width: 94%;
}
.lineborder{
  width:200px;
  height:1px;
  opacity:0.2965;
  background-color: #2F77C0; 
}
.sidemenu{
  width:100%;
}
.sidemenu.up{
  height:59px;
  overflow: hidden;
}
.sidemenu h4{
  width:100%;
  height:58px;
  line-height:58px;
  color: #fff;
  text-indent: 60px;
  position: relative;
  cursor: pointer;
}
.sidemenu.dow{
  height:auto;
  display: table;
  overflow: unset;
  background: rgb(75, 159, 243);
  color:#ffffff;
}
.sidemenu.dow h4{
  background-color:#3A84EC;
}
.sidemenu h4::before{
  position: absolute;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  right: 10px;
}
.sidemenu.up h4::before{
  font-size: 14px;
  content: "\e601";
}
.sidemenu.dow h4::before{
  font-size: 14px;
  content: "\e602";
}
.sidemenu h4 i{
  position: absolute;
  font-size: 22px;
  left:-30px;
  top:1px;
}
.itemnavlist li:hover{
  background-color: rgba(47, 120, 192, 0.3);
}
.itemnavlist>li>ul{
  width:100%;
  height:90px;
}
.itemnavlist>li>ul>li{
  height:45px;
  line-height:45px;
  font-size: 14px;
}
.itemnavlist > li > div{
  position:relative;
  width:200px;
  clear: both;
  height:45px;
  display: block;
}
.itemnavlist > li > div:before {
  position: absolute;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  right: 10px;
  top:2px;
  font-size: 22px;
}
.itemnavlist > li.on > div:before {
  content: "\e725";
}
.itemnavlist > li.off > div:before {
  content: "\e726";
}
.itemnavlist > li.off{
  height:45px;
  line-height:45px;
  overflow: hidden;
}
.itemnavlist > li.on{
  height: auto;
  overflow:visible;
  display: table;
  background-color: #4293E4;
}
.on>div{
  opacity: 0.3;
}
.itemnavlist li.nono {
    background-color: rgba(47, 120, 192, 0.3);
}
.icon-iconfinderbank::before{
  font-size: 18px;
  text-align: center;
}
.onno{
  background: #2F77C0;
  opacity: 0.3;
}
.dow h4{
  opacity: 0.3;
}
.helpcapsule{
width:100px;
height:22px;
line-height: 22px;
border-top-right-radius:22px;
border-bottom-right-radius:22px;
display: block;
border:1px solid #ccc;
position: absolute;
left:0;
top:2px;
background: #fff;
cursor: pointer;
color: #666;
}
.helpcapsule span::before{
  font-size: 28px;
   float: left;
   display: block;
}
.helpcapsule:hover{
  color:#333;
  background: linear-gradient(#efefef, #fff); 
}

.ayy::before {
  content: "\e6b5";
  font-size: 32px;
  margin-left:-4px;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-web-icon-ad:before {
  content: "\e6b5";
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>




// WEBPACK FOOTER //
// src/page/bankacceptance/index.vue